import { TemplateRef } from '@angular/core';
import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
import { ButtonModel } from '../button/button.model';
import { ToolbarModel } from '../toolbar/toolbar.model';
export class DialogModel extends CoreModel {
/**
 * ID of the target component inside which dialog will be opened.
 */
targetId?: string;
/**
 * If to align dialog position according to the trigger which opened dialog.
 */
sourceEvent?: any;
/**
 * Position of the dialog according to the trigger. Can be: auto, leftUp, leftBelow, rightBelow, rightUp.
 */
position?: string;
/**
 * Whether the user can use escape or clicking outside to close a modal.
 */
disableClose?: boolean;
/**
 * Height of the dialog.
 */
height?: string;
/**
 * Width of the dialog.
 */
width?: string;
/**
 * Dialog header object.
 */
header?: {
    /**
     * Whether to show header.
     */
    show?: boolean;
    /**
     * Toolbar inside header.
     */
    toolbar?: ToolbarModel;
  };
/**
 * Dialog content object.
 */
content?: {
    /**
     * Whether to show content.
     */
    show?: boolean;
    /**
     * Dialog message text.
     */
    message?: string;
    /**
     * Template for the content.
     */
    template?: TemplateRef<any>;
  };
/**
 * Dialog footer object.
 */
footer?: {
    /**
     * Whether to show footer.
     */
    show?: boolean;
    /**
     * Footer cancel button.
     */
    cancelButton?: {
      /**
         * Whether to show footer cancel button.
         */
      show?: boolean;
      /**
         * Footer cancel button model.
         */
      button?: ButtonModel;
    };
    /**
     * Footer ok button.
     */
    okButton?: {
      /**
         * Whether to show footer ok button.
         */
      show?: boolean;
      /**
         * Footer ok button model.
         */
      button?: ButtonModel;
    };
    /**
     * Template for the footer.
     */
    template?: TemplateRef<any>;
  };
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function DialogModel_tsickle_Closure_declarations() {
/**
 * ID of the target component inside which dialog will be opened.
 * @type {?}
 */
DialogModel.prototype.targetId;
/**
 * If to align dialog position according to the trigger which opened dialog.
 * @type {?}
 */
DialogModel.prototype.sourceEvent;
/**
 * Position of the dialog according to the trigger. Can be: auto, leftUp, leftBelow, rightBelow, rightUp.
 * @type {?}
 */
DialogModel.prototype.position;
/**
 * Whether the user can use escape or clicking outside to close a modal.
 * @type {?}
 */
DialogModel.prototype.disableClose;
/**
 * Height of the dialog.
 * @type {?}
 */
DialogModel.prototype.height;
/**
 * Width of the dialog.
 * @type {?}
 */
DialogModel.prototype.width;
/**
 * Dialog header object.
 * @type {?}
 */
DialogModel.prototype.header;
/**
 * Dialog content object.
 * @type {?}
 */
DialogModel.prototype.content;
/**
 * Dialog footer object.
 * @type {?}
 */
DialogModel.prototype.footer;
}

